import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=eb828faa&scoped=true&"
import script from "./CountryFlag.vue?vue&type=script&lang=js&"
export * from "./CountryFlag.vue?vue&type=script&lang=js&"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=eb828faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb828faa",
  null
  
)

export default component.exports